import { Modal, Form, Button } from '@themesberg/react-bootstrap'
import { ErrorMessage, Formik } from 'formik'
import React from 'react'
import { reasonSchema, sendEmailSchema } from '../../../Tenant/Users/schemas'
import { emailTempaltesConstants, userDisableReasons } from '../constants'

const SendEmailModal = ({
  show,
  handleClose,
  emailTemplates,
  handleSendUserEmail,
  name
}) => {
  return (
    <>
      <Formik
        initialValues={{
          templateType:''
        }}
        validationSchema={sendEmailSchema}
        onSubmit={(formValues, { resetForm }) => {
          handleSendUserEmail(formValues)
          resetForm({ formValues: '' })
          handleClose()
        }}
      >
        {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
          <Modal
            show={show}
            onHide={handleClose}
            backdrop='static'
            keyboard={false}
          >
            <Modal.Header closeButton>
              <h5>Send Mail to {name || 'Player'}</h5>
            </Modal.Header>
            <Modal.Body>
              <div className='form-group'>
                <label
                  htmlFor='reason'
                  className={touched.reason && errors.reason ? 'text-danger' : ''}
                >
                  Email Template<span className='text-danger'> *</span>
                </label>
                <Form.Select
                  name='templateType'
                  value={values.templateType}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={touched.templateType && errors.templateType ? 'border border-danger' : ''}
                >
                  <option value=''>Select Reason</option>
                  {Object.keys(emailTemplates).map((key, index) => <option value={emailTempaltesConstants[key]} key={emailTemplates[key]?.[0].emailTemplateId}>{key}</option>)}
                </Form.Select>
                <ErrorMessage
                  component='div'
                  name='reason'
                  className='text-danger'
                />
              </div>
            </Modal.Body>
            <div className='mt-4 '>
              <Modal.Footer className='d-flex justify-content-between align-items-center'>
                <Button
                  variant='outline-warning'
                  onClick={handleClose}
                >
                  Cancel
                </Button>
                <Button
                  variant='outline-success'
                  onClick={handleSubmit}
                  className='ml-2'
                >
                  Submit
                </Button>
              </Modal.Footer>
            </div>
          </Modal>
        )}

      </Formik>
    </>
  )
}

export default SendEmailModal
